import { Col } from 'antd';
import { FC, ReactNode } from 'react';

import styles from './styles.module.scss';

type Props = {
  children: ReactNode;
};

export const Label: FC<Props> = ({ children }) => {
  return <Col className={styles.label}>{children}</Col>;
};
